import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';
import { IGemCreationPayload, IGemUpdatePayload, IGetGemByIdPayload, IGetGemsPayload } from '../redux/gem/gemSlice';
import { GemBankType } from '../utils/enums/gem-bank.enum';

export async function getGems({
  page,
  limit,
  sortBy,
  sortOrder,
  search,
  selectedFilterOptions,
  type,
}: IGetGemsPayload): Promise<AxiosResponse> {
  const filterParams: { [key: string]: string | string[] } = {};

  selectedFilterOptions.forEach((option) => {
    Object.keys(option).forEach((gemFeature) => {
      filterParams[gemFeature] = option[gemFeature];
    });
  });

  if (type === GemBankType.POROLIS) {
    return backendApiInstance.get('/gems/gem-bank', {
      params: { page, limit, sortBy, sortOrder, search, ...filterParams, type: GemBankType.POROLIS },
    });
  }
  return backendApiInstance.get('/gems', {
    params: { page, limit, sortBy, sortOrder, search, ...filterParams, type },
  });
}

export async function getFavGems({
  page,
  limit,
  sortBy,
  sortOrder,
  search,
  selectedFilterOptions,
}: IGetGemsPayload): Promise<AxiosResponse> {
  const filterParams: { [key: string]: string | string[] } = {};

  selectedFilterOptions.forEach((option) => {
    Object.keys(option).forEach((gemFeature) => {
      filterParams[gemFeature] = option[gemFeature];
    });
  });

  return backendApiInstance.get('/gems/favourite', {
    params: { page, limit, sortBy, sortOrder, search, ...filterParams },
  });
}

export async function addFavouriteGem(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.post(`/gems/favourite/${gemId}`);
}

export async function removeFavouriteGem(favouriteId: string): Promise<AxiosResponse> {
  return backendApiInstance.delete(`/gems/favourite/${favouriteId}`);
}

export async function toggleGemPublic(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.put(`/gems/toggle-public/${gemId}`);
}

export async function getGemById({ gemId, type }: IGetGemByIdPayload): Promise<AxiosResponse> {
  return backendApiInstance.get(`/gems/${gemId}`, { params: { type } });
}

export async function addGem(gem: IGemCreationPayload): Promise<AxiosResponse> {
  return backendApiInstance.post(`/gems`, gem);
}

export async function editGem(payload: { gem: IGemUpdatePayload; gemId: string }): Promise<AxiosResponse> {
  return backendApiInstance.patch(`/gems/${payload.gemId}`, payload.gem);
}

export async function deleteGem(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.delete(`/gems/${gemId}`);
}

export async function getGemMediaDownloadUrl(gemId: string, mediaType?: 'IMAGE' | 'VIDEO'): Promise<AxiosResponse> {
  return backendApiInstance.get(`/gems/${gemId}/media-download-url`, {
    params: { mediaType },
  });
}
export async function generateGemPassport(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.put(`/gems/${gemId}/generate-gem-passport`);
}

export async function generateGemPassportLight(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.put(`/gems/${gemId}/generate-gem-passport-light`);
}

export async function lockEditGem(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.patch(`/gems/lock/${gemId}`);
}

export async function unlockEditGem(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.patch(`/gems/unlock/${gemId}`);
}

export async function checkGemLockStatus(gemId: string): Promise<AxiosResponse> {
  return backendApiInstance.get(`/gems/check-gem-lock-status/${gemId}`);
}
